import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const CheckinsRedux = createActions({
  CheckinsExcelRequest: [''],
  CheckinsExcelSuccess: [''],
  CheckinsExcelError: ['error'],
},
{
  prefix: 'CHECKINS_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = CheckinsRedux
export const CheckinsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const CheckinsExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const CheckinsExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const CheckinsExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CheckinsExcelRequest]: CheckinsExcelRequest,
  [Types.CheckinsExcelSuccess]: CheckinsExcelSuccess,
  [Types.CheckinsExcelError]: CheckinsExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/CheckinsRedux.js